module.exports = __webpack_public_path__ + "img/home-3.e928dc0f.webp";